import React, { useEffect, useState } from 'react';
import {
  Row, Col, Button, Table, Card, Spinner, Container,
} from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import { ButtonKembali, Content } from '../styles';
import Navbar from '../../../../components/Navbar';
import Header from '../../../../components/Header';
import { Loader } from '../../../Superadmin/TambahAdmin/styles';
import config from '../../../../config';
import ModalTolak from './ModalTolak';
import ModalSetuju from './ModalSetuju';
import ModalKonfirmasi from '../../../../components/ModalKonfirmasi';

const DetailApprovalPartisipasi = () => {
  const [loading, setLoading] = useState(true);
  const [dataDetail, setDataDetail] = useState({ mahasiswa: { user: {} }, kum: { } });
  const [showTolak, setShowTolak] = useState(false);
  const [showSetuju, setShowSetuju] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const { idMahasiswa } = useParams();
  const history = useHistory();

  const fetchDetail = () => {
    setLoading(true);
    axios.get(`${config.API_BASE_URL}api/partisipasi_kuliah_umum/detail/${idMahasiswa}/`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      ({ data }) => {
        const tempData = data;
        tempData.kum.biaya = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(data.kum.biaya);
        setDataDetail(data);
      },
    );
    setLoading(false);
  };

  const SubmitExistingKum = () => {
    const formData = { nilai_kum: dataDetail.kum.nilai_kum, status: 'disetujui' };
    axios.put(`${config.API_BASE_URL}api/partisipasi_kuliah_umum/detail/${dataDetail.id}/`, formData, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      () => {
        history.push('/Admin/DaftarPengajuanPartisipasi/DaftarApprovalPartisipasi');
      },
    );
  };

  const handleApprove = () => {
    if (dataDetail.kum.nilai_kum === null) {
      setShowSetuju(true);
    } else {
      setModalShow(true);
    }
  };

  const handleBack = () => {
    history.push('/Admin/DaftarPengajuanPartisipasi/DaftarApprovalPartisipasi');
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  return (
    <>
      <Navbar />
      <Header />
      <Container className="mt-4">
        <Content>
          <Card>
            <Card.Header>
              <ButtonKembali onClick={handleBack}>
                Kembali
              </ButtonKembali>
              <div className={Content}>
                <h3 className="text-center">
                  Detail Pengajuan Partisipasi Kegiatan Kuliah Umum
                </h3>
              </div>
            </Card.Header>
            <Card.Body>
              <div>
                <Row>
                  <Col md={{ span: 6 }}>
                    <div>
                      <Table responsive="sm">
                        <tbody>
                          <tr>
                            <td>Nama Pengaju</td>
                            <td>{dataDetail.mahasiswa.user.name}</td>
                          </tr>
                          <tr>
                            <td>NPM</td>
                            <td>{dataDetail.mahasiswa.user.npmnip}</td>
                          </tr>
                          <tr>
                            <td>Prodi</td>
                            <td>{dataDetail.mahasiswa.prodi}</td>
                          </tr>
                          <tr>
                            <td>Jenis Kegiatan</td>
                            <td>{dataDetail.kum.jenis_kegiatan}</td>
                          </tr>
                          <tr>
                            <td>Dokumen</td>
                            <td>
                              <a
                                style={{
                                  display: 'inline-block', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', width: '20em',
                                }}
                                href={dataDetail.bukti_registrasi}
                              >
                                {dataDetail.bukti_registrasi}
                              </a>
                              {dataDetail?.sertifikat && (
                              <a
                                style={{
                                  display: 'inline-block', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', width: '20em',
                                }}
                                href={dataDetail.sertifikat}
                              >
                                {dataDetail.sertifikat}
                              </a>
                              )}

                            </td>
                          </tr>

                        </tbody>
                      </Table>
                    </div>
                  </Col>
                  <Col md={{ span: 6 }}>
                    <div>
                      <Table responsive="sm">
                        <tbody>
                          <tr>
                            <td>Nama Kegiatan</td>
                            <td>{dataDetail.kum.nama_kegiatan}</td>
                          </tr>
                          <tr>
                            <td>Narasumber</td>
                            <td>{dataDetail.kum.jenis_kegiatan}</td>
                          </tr>
                          <tr>
                            <td>Hari/Tanggal</td>
                            <td>{dataDetail.kum.tanggal}</td>
                          </tr>
                          <tr>
                            <td>Pukul</td>
                            <td>{dataDetail.kum.tanggal}</td>
                          </tr>
                          <tr>
                            <td>Penyelenggara</td>
                            <td>{dataDetail.kum.penyelenggara}</td>
                          </tr>
                          <tr>
                            <td>Biaya</td>
                            <td>{dataDetail.kum.biaya}</td>
                          </tr>
                          <tr>
                            <td>Lokasi</td>
                            <td>{dataDetail.kum.lokasi}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
                {dataDetail.status === 'menunggu persetujuan'
                && (
                <Row>
                  <Col className="text-center">
                    <Button className="btnCancel btn-primary mr-2" onClick={() => setShowTolak(true)} variant="danger" data-testid="tolak">Ditolak</Button>
                    <Button className="btnKirim btn-primary" onClick={() => handleApprove()} variant="success" data-testid="setuju">Disetujui</Button>
                  </Col>
                </Row>
                )}

              </div>
            </Card.Body>
          </Card>
          <ModalSetuju
            id={dataDetail.id}
            show={showSetuju}
            onHide={() => setShowSetuju(false)}
            history={history}
          />
          <ModalKonfirmasi
            show={modalShow}
            onHide={() => setModalShow(false)}
            onSubmit={() => { SubmitExistingKum(); setModalShow(false); }}
          />
          <ModalTolak
            id={dataDetail.id}
            show={showTolak}
            onHide={() => setShowTolak(false)}
            history={history}
          />
        </Content>
      </Container>
    </>
  );
};

export default DetailApprovalPartisipasi;
